import { useMemo, useEffect } from 'react'
import { createStore, createEvent, clearNode } from 'effector'
import { useStore } from 'effector-react'
import { VoidFnType } from '@rst/libs-ts'

type ModalStoreType = { def: boolean; afterClose?: VoidFnType }

export const useModalStore = ({ def, afterClose }: ModalStoreType) => {
	const { toggle, open, close, $store } = useMemo(() => {
		const toggle = createEvent<void>()
		const open = createEvent<void>()
		const close = createEvent<void>()
		const $store = createStore<boolean>(def)
		$store
			.on(toggle, s => !s)
			.on(open, _ => true)
			.on(close, _ => false)

		if (afterClose) {
			close.watch(afterClose)
		}

		return { toggle, open, close, $store }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => () => clearNode($store, { deep: true }), [])
	const view = useStore($store)

	return { toggle, open, close, view }
}
